import { useTranslation } from 'react-i18next';

// Import helpers
import { createLinkParams } from 'helpers';

const useDetailsButton = (id: string, type: string, title: string) => {
	const { t } = useTranslation();
	const buttonText = t('vod_buttons_play');

	const linkRedirect = createLinkParams({ id, type, title });

	return {
		buttonText,
		linkRedirect
	};
};

export default useDetailsButton;
